export default __webpack_public_path__ + "static/media/rotate.f140e852.svg";